import React from "react";
import Wrapper from "../components/Wrapper";
import { Link } from "react-router-dom";
import { translations } from "../langauge";
import { useLang } from "../context/LanguageContext";
import MobileBottomMenu from "../components/MobileBottomMenu";

const Vinzz = () => {
  const { lang } = useLang();

  const navlinks = [
    {
      id: 1,
      title: translations[lang].vinzz,
      link: "/",
      active: true,
    },
    {
      id: 2,
      title: translations[lang].the_architect,
      link: "/",
      active: false,
    },
    {
      id: 3,
      title: translations[lang].chef_designer,
      link: "/",
      active: false,
    },
  ];

  return (
    <Wrapper>
      <div className="row commonRowClass">
        <div className="col-lg-3 col-md-4 col-12 ">
          <div
            className="rightSideDiv"
          >
            <div className="navbarDiv">
              <ul>
                {navlinks &&
                  navlinks?.map((nav) => {
                    return (
                      <li key={nav.id}>
                        <Link
                          to={nav.link}
                          style={{ textAlign: lang == "en" ? "left" : "right" }}
                          className={nav.active == true ? "active" : ""}
                        >
                          {nav.title}
                        </Link>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-lg-9 col-md-8 col-12">
          <div className="contentDiv">
            <h1 className="commonHeading">Vinzz</h1>
            <div className="contentImg">
              <img src="https://subpop-img.s3.amazonaws.com/asset/artist_images/attachments/000/009/501/max_960/dummy-2022-promo-02-alexbulli-2100x1400-300.jpg?1653589239" />
            </div>
            <p className="commonpara">{translations[lang].vinzz_paraone}</p>
          </div>
        </div>
      </div>
      <MobileBottomMenu title={"Vinzz"} />
    </Wrapper>
  );
};

export default Vinzz;
